<div class="wallList__row"
     [ngClass]="expanded ? 'expand' : 'collapse'">
  <app-entity-follow-up-flag [cornerFlag]="true"
                             [entityId]="entityId"
                             [campaignId]="campaignId">
  </app-entity-follow-up-flag>
  <div class="wallList__header wlHeader flex flexAlign--center flexJustify--between">

    <div class="wlHeader__main flex flexAlign--center">
      <!--TODO: pass size (for avatar) if we need to
                When the card is clicked, it triggers an event
                for parent component to list to-->
      <app-entity-basic-card class="pointer-on-hover"
                             aria-roledescription="Navigation"
                             (click)="onBasicCardClicked()"
                             [entityId]="entityId"
                             [campaignId]="campaignId">

      </app-entity-basic-card>
      <!-- Quick Actions Button -->
      <ng-container *ngIf="showQuickActionsButton">
        <button type="button"
                class="quick-actions-btn btn btn--mat-white txt-15 float-r flexOrder-3"
                [ngClass]="{'active': quickActionsMenuOpen}"
                [matMenuTriggerFor]="quickActionsMenu"
                (menuOpened)="quickActionsMenuOpen = true"
                (menuClosed)="quickActionsMenuOpen = false">
          <i class="fal fa-magic-wand-sparkles mr-0025"></i>
          <span>Quick Actions&hellip;</span>
        </button>
        <mat-menu #quickActionsMenu="matMenu"
                  class="quick-actions-menu">
          <app-entity-action-box [entityId]="entityId"
                                 [campaignId]="campaignId"
                                 [showRemove]="showRemoveEntity"
                                 [showMerge]="showMergeEntity"
                                 class="actions">
          </app-entity-action-box>
        </mat-menu>
      </ng-container>
    </div>

    <button mat-icon-button
            aria-label="Toggle Details"
            (mouseover)="prefetchToplines()"
            (click)="toggleExpanded($event)">

      <mat-icon fontSet="fal fa-fw"
                [fontIcon]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></mat-icon>
    </button>
  </div>

  <div class="wallList__core wlCore">
    <app-entity-contact-buttons [entityId]="entityId"
                                [campaignId]="campaignId"
                                [opensLogContactModal]="contactButtonsOpensLogContactModal"
                                class="wlCore__contact">
    </app-entity-contact-buttons>
  </div>

  <!-- Display content lazy-->
  <ng-container *ngIf="lazyToplines">
    <div class="wallList__content wlContent"
         *ngIf="expanded">
      <app-entity-toplines [entityId]="entityId"
                           [campaignId]="campaignId"
                           class="toplines flex flexAlign--baseline">
      </app-entity-toplines>

      <app-entity-action-box [entityId]="entityId"
                             [campaignId]="campaignId"
                             [showRemove]="showRemoveEntity"
                             [showMerge]="showMergeEntity"
                             class="actions">
      </app-entity-action-box>
    </div>
  </ng-container>

  <!-- Preload and hide content-->
  <ng-container *ngIf="!lazyToplines">
    <div class="wallList__content wlContent"
         [ngClass]="{'d-none':!expanded}">
      <app-entity-toplines [entityId]="entityId"
                           [campaignId]="campaignId"
                           class="toplines flex flexAlign--baseline">
      </app-entity-toplines>

      <app-entity-action-box [entityId]="entityId"
                             [campaignId]="campaignId"
                             [showRemove]="showRemoveEntity"
                             [showMerge]="showMergeEntity"
                             class="actions">
      </app-entity-action-box>
    </div>
  </ng-container>


  <!-- END EXPANDED CARD -->

  <div class="wallList__footer wlFooter c-default bg-color--gray--000">

    <ng-content select="[entity-list-row-footer]"></ng-content>

  </div>

  <ng-content select="[entity-list-row-footer-2]"></ng-content>
</div>
